exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Realtime__container___23o3C {\n  background-color: rgba(221, 229, 237, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #5d7186;\n  font-size: 12px;\n  flex-direction: column;\n  padding: 10px 0;\n}\n\n.Realtime__content___30Fex {\n  display: flex;\n  align-items: center;\n}\n\n.Realtime__icon___1E2zH {\n  width: 12px;\n  height: 12px;\n  color: #5d7186;\n  fill: #5d7186;\n  margin-right: 10px;\n}\n\n.Realtime__chevronDown___3rzsh {\n  margin-top: 10px;\n  width: 12px;\n  height: 12px;\n  color: #5d7186;\n  fill: #5d7186;\n}\n\n@media (min-width: 800px) {\n  .Realtime__chevronDown___3rzsh {\n    display: none;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"container": "Realtime__container___23o3C",
	"content": "Realtime__content___30Fex",
	"icon": "Realtime__icon___1E2zH",
	"chevronDown": "Realtime__chevronDown___3rzsh"
};